<template>
    <dash
        icon="fa fa-user-plus"
        titulo="NOVOS FORNECEDORES NO MÊS"
        :qtd="qtd"
        :loading="loading"
        color="#16C172"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
	props: {
		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
